export const formatPrice = (n) => {
  if (n === null || n === undefined) return '';
  return new Intl.NumberFormat('ro-RO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n) + ' lei';
};
